// Maps product handles to Postgres product UUIDs (for reviews lookups).
export const PRODUCT_IDS: Record<string, string> = {
  "mag-absorb-pro": "d678e9a5-34ae-4d0e-a9bd-c3be83ed9baa",
  "liver-biome-plus": "bd9da9a9-5d81-47a9-9333-58cf43c09f27",
  "ova-balance": "a3cb38f6-7e78-45c0-acb6-bd050e509786",
};

export function productIdForHandle(handle: string | undefined | null): string | null {
  if (!handle) return null;
  return PRODUCT_IDS[handle] ?? null;
}
